import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SettingComponent } from './setting/setting.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { SharedModule } from "@rubii/frontend-common";
import { PasswordModule } from '../password/password.module';
import { ResetComponent } from '../password/reset/reset.component';
import { NavigateComponent } from './navigate/navigate.component';
import { DatasourceComponent } from './datasource/datasource.component';
import { RolesComponent } from './roles/roles.component';
import { DoneComponent } from './done/done.component';
import { DatasourceConnectionComponent } from './datasource-connection/datasource-connection.component';
import { MatSelectModule } from '@angular/material/select';
import { TenantComponent } from "./tenant/tenant.component";
import { BaseDatasourceComponent } from './datasource/base-datasource/base-datasource.component';
import { DatasourceDirective } from './datasource/directives/datasource.directive';
import { VistarComponent } from './datasource/vistar/vistar.component';
import { QuantcastComponent } from './datasource/quantcast/quantcast.component';
import { DataStudioComponent } from './datasource/data-studio/data-studio.component';
import { MediaMathComponent } from './datasource/media-math/media-math.component';
import { TtdComponent } from './datasource/ttd/ttd.component';
import { XandrComponent } from './datasource/xandr/xandr.component';
import { ZemantaComponent } from './datasource/zemanta/zemanta.component';
import { AmobeeComponent } from './datasource/amobee/amobee.component';
import { IasComponent } from './datasource/ias/ias.component';
import { AdobeComponent } from './datasource/adobe/adobe.component';
import { NielsenComponent } from './datasource/nielsen/nielsen.component';
import { SizmekComponent } from './datasource/sizmek/sizmek.component';
import { PinterestComponent } from './datasource/pinterest/pinterest.component';
import { Dv360Component } from './datasource/dv360/dv360.component';
import { DcmComponent } from './datasource/dcm/dcm.component';
import { Sa360Component } from './datasource/sa360/sa360.component';
import { GAdsComponent } from './datasource/gads/gads.component';
import { VerizonComponent } from './datasource/verizon/verizon.component';
import { DoubleVerifyComponent } from "./datasource/double-verify/double-verify.component";
import { XyzComponent } from './datasource/xyz/xyz.component';
import { AdobeSearchComponent } from './datasource/adobe-search/adobe-search.component';
import { TaboolaComponent } from './datasource/taboola/taboola.component';
import { OutbrainComponent } from './datasource/outbrain/outbrain.component';
import { NoParamsComponent } from './datasource/_noparams/noparams.component';
import { LifesightComponent } from './datasource/lifesight/lifesight.component';
import { CriteoComponent } from './datasource/criteo/criteo.component';
import { environment } from '../../environments/environment';
import { StackadaptComponent } from './datasource/stackadapt/stackadapt.component';
import { ChatgptComponent } from './datasource/chatgpt/chatgpt.component';
import { BlisComponent } from './datasource/blis/blis.component';
import { MoatComponent } from './datasource/moat/moat.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { EditUserComponent } from './edit-user/edit-user.component';
import { RoleSelectorComponent } from './role-selector/role-selector.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SearchInlineComponent } from './search-inline/search-inline.component';
import { ExUserAccessSelector } from './ex-user-access-selector/ex-user-access-selector.component';
import { MatMenuModule } from '@angular/material/menu';
import { RoktComponent } from './datasource/rokt/rokt.component';
import { ShopifyComponent } from './datasource/shopify/shopify.component';
import { DatasourcesComponent } from './datasource/datasources/datasources.component';
import { DatasourceDetailComponent } from './datasource/datasource-detail/datasource-detail.component';
import { AdformComponent } from './datasource/adform/adform.component';
import { KlaviyoComponent } from './datasource/klaviyo/klaviyo.component';
import { PubmaticComponent } from './datasource/pubmatic/pubmatic.component';
import { ChannelFactoryComponent } from './datasource/channel-factory/channel-factory.component';
import { CommonPopupComponent } from './datasource/_common-popup/common-popup.component';
import { CustomMetricListComponent } from './custom-field/custom-metric/custom-metric-list.component';
import { XeroComponent } from './datasource/xero/xero.component';
import { AiAgentComponent } from './setting/ai/ai-agent/ai-agent.component';
import { MarkdownModalComponent } from './setting/ai/ai-agent/markdown-modal.component';
import { AiToolComponent } from './setting/ai/ai-tool/ai-tool.component';
import { AiToolExecutionsComponent } from './setting/ai/ai-tool-executions/ai-tool-executions.component';
import { JsonPopupComponent } from './setting/ai/ai-tool-executions/json-popup.component';
import { AiPromptComponent } from './setting/ai/ai-prompt/ai-prompt.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ImageModalComponent } from './setting/ai/ai-bot/image-modal/image-modal.component';
import { AiBotComponent } from './setting/ai/ai-bot/ai-bot.component';
import { AiMessageToolComponent } from './setting/ai/ai-bot/ai-message-tool/ai-message-tool.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { UtilService } from '../services/util.service';
import { CustomFieldComponent } from './custom-field/custom-field.component';
import { CustomDimensionListComponent } from './custom-field/custom-dimension/custom-dimension-list.component';
import { Scope3Component } from './datasource/scope3/scope3.component';
import { MatRadioModule } from '@angular/material/radio';
import { ShareModule } from '../shared/share.module';
import { OtpVerificationDialogComponent } from './setting/otp-verification-dialog/otp-verification-dialog.component';
import { GamComponent } from './datasource/gam/gam.component';
import { YahoojpComponent } from './datasource/yahoojp/yahoojp.component';
import { EntraComponent } from './datasource/entra/entra.component';
import { EntraConfigComponent } from './entra-config/entra-config.component';
import { GoogleSsoComponent } from './datasource/google-sso/google-sso.component';
import { GoogleSsoConfigComponent } from './google-sso-config/google-sso-config.component';
import { SeedoohComponent } from './datasource/seedooh/seedooh.component';
import { CustomModule } from './datasource/custom/custom.module';

@NgModule({
    declarations: [
        ExUserAccessSelector,
        SearchInlineComponent,
        RoleSelectorComponent,
        EditUserComponent,
        SettingComponent,
        TenantComponent,
        NavigateComponent,
        DatasourceComponent,
        RolesComponent,
        DoneComponent,
        DatasourceConnectionComponent,
        DoubleVerifyComponent,
        BaseDatasourceComponent,
        DatasourceDirective,
        VistarComponent,
        QuantcastComponent,
        DataStudioComponent,
        XyzComponent,
        MediaMathComponent,
        TtdComponent,
        XandrComponent,
        ZemantaComponent,
        AmobeeComponent,
        IasComponent,
        Scope3Component,
        AdobeComponent,
        NielsenComponent,
        SizmekComponent,
        StackadaptComponent,
        ChatgptComponent,
        PinterestComponent,
        Dv360Component,
        GamComponent,
        DcmComponent,
        Sa360Component,
        GAdsComponent,
        VerizonComponent,
        NoParamsComponent,
        AdobeSearchComponent,
        TaboolaComponent,
        OutbrainComponent,
        CommonPopupComponent,
        LifesightComponent,
        CriteoComponent,
        BlisComponent,
        MoatComponent,
        RoktComponent,
        DatasourcesComponent,
        DatasourceDetailComponent,
        ShopifyComponent,
        AdformComponent,
        KlaviyoComponent,
        PubmaticComponent,
        ChannelFactoryComponent,
        XeroComponent,
        CustomMetricListComponent,
        MarkdownModalComponent,
        AiAgentComponent,
        AiToolComponent,
        AiToolExecutionsComponent,
        JsonPopupComponent,
        AiPromptComponent,
        AiBotComponent,
        AiMessageToolComponent,
        ImageModalComponent,
        CustomFieldComponent,
        CustomDimensionListComponent,
        OtpVerificationDialogComponent,
        YahoojpComponent,
        EntraComponent,
        EntraConfigComponent,
        GoogleSsoComponent,
        GoogleSsoConfigComponent,
        SeedoohComponent,
    ],
    imports: [
        CommonModule,
        MatTabsModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatCardModule,
        MatGridListModule,
        MatButtonModule,
        MatTableModule,
        MatDialogModule,
        MatCheckboxModule,
        MatDividerModule,
        MatSnackBarModule,
        FormsModule,
        SharedModule,
        PasswordModule,
        MatPaginatorModule,
        MatStepperModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatMenuModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatRadioModule,
        ShareModule,
        MatProgressSpinnerModule,
        CustomModule,
    ],
    providers: [
        { provide: 'fetchCurrenciesUrl', useValue: environment.orderRoot + `order/currencies?domain=order` },
        { provide: 'dashboardRoot', useValue: environment.dashboardRoot},
        {provide: 'advertiserRoot', useValue: environment.advertiserRoot},
        {provide: 'customMetricRoot', useValue: environment.customMetricRoot},
        {provide: 'toolRoot', useValue: environment.toolRoot},
        UtilService
    ]
})
export class AccountModule { }
